import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchCarTypes } from "../api";
import "bootstrap/dist/css/bootstrap.min.css";
import "../style/Fleet.css"; // Import custom CSS for styling
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserFriends,
  faCouch,
  faSuitcaseRolling,
  faBriefcase,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import SEO from "./SEO";

const Fleet = () => {
  const [carTypes, setCarTypes] = useState([]);

  useEffect(() => {
    fetchCarTypes()
      .then((response) => setCarTypes(response.data))
      .catch((error) => console.error(error));
  }, []);

  // Map car types to detail page routes
  const getDetailRoute = (carType) => {
    const typeMap = {
      'SUV': '/fleet/suv',
      'Sedan': '/fleet/sedan',
      'Sprinter': '/fleet/sprinter',
      'Stretch': '/fleet/stretch'
    };
    return typeMap[carType] || '/fleet';
  };

  const fleetJsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Vehicle Fleet Services",
    "description": "Premium transportation fleet featuring luxury SUVs, executive sedans, spacious sprinter vans, and elegant stretch limousines.",
    "provider": {
      "@type": "Organization",
      "name": "Gators Transportation"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Vehicle Fleet",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Product",
            "name": "Luxury SUV",
            "description": "Premium SUV transportation with spacious interior and advanced safety features"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Product",
            "name": "Executive Sedan",
            "description": "Professional sedan service perfect for business travel and airport transfers"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Product",
            "name": "Sprinter Van",
            "description": "Group transportation solution with comfortable seating for up to 12 passengers"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Product",
            "name": "Stretch Limousine",
            "description": "Luxury stretch limousine for special occasions and VIP transportation"
          }
        }
      ]
    }
  };

  return (
    <div className="fleet-container">
      <SEO
        title="Our Fleet"
        description="Explore Gators Transportation's premium vehicle fleet. Choose from luxury SUVs, executive sedans, spacious sprinter vans, and elegant stretch limousines for your transportation needs."
        keywords="vehicle fleet, luxury SUV, executive sedan, sprinter van, stretch limousine, premium vehicles, transportation fleet"
        jsonLd={fleetJsonLd}
      />
      
      <section className="fleet-section">
        <h2 className="text-center mb-3">Our Fleet</h2>
        <h6 className="text-center mb-3">
          Explore top-tier vehicles: comfort, style, and reliability combined.
        </h6>

        {/* Responsive Grid */}
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-0">
          {carTypes.map((car) => (
            <div className="col" key={car.car_id}>
              <div className="fleet-card h-100">
                <div className="fleet-image-wrapper">
                  <img
                    src={`/images/${car.car_type
                      .toLowerCase()
                      .replace(/\s+/g, "_")}.avif`}
                    className="fleet-image"
                    alt={car.car_type}
                  />
                  <div className="fleet-gradient-overlay"></div>
                </div>
                <div className="fleet-card-body">
                  <h5 className="fleet-card-title">{car.car_type}</h5>
                  <div className="fleet-details">
                    <div className="fleet-detail-item">
                      <FontAwesomeIcon icon={faUserFriends} className="fleet-icon" />
                      <span className="fleet-detail-text">
                        <strong>Passengers:</strong> {car.passenger_capacity}
                      </span>
                    </div>
                    <div className="fleet-detail-item">
                      <FontAwesomeIcon icon={faCouch} className="fleet-icon" />
                      <span className="fleet-detail-text">
                        <strong>Seats:</strong> {car.seat_type}
                      </span>
                    </div>
                    <div className="fleet-detail-item">
                      <FontAwesomeIcon icon={faSuitcaseRolling} className="fleet-icon" />
                      <span className="fleet-detail-text">
                        <strong>Large Luggage:</strong> {car.large_luggage_capacity}
                      </span>
                    </div>
                    <div className="fleet-detail-item">
                      <FontAwesomeIcon icon={faBriefcase} className="fleet-icon" />
                      <span className="fleet-detail-text">
                        <strong>Carry-On:</strong> {car.carry_on_capacity}
                      </span>
                    </div>
                  </div>
                  
                  {/* View Details Button */}
                  <div className="fleet-card-footer">
                    <Link 
                      to={getDetailRoute(car.car_type)} 
                      className="fleet-detail-btn"
                    >
                      <FontAwesomeIcon icon={faEye} className="me-2" />
                      View Details
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Fleet;
